import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonService } from 'app/services/common.service';
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { LoginInfoProvider } from '../ev-dal/login-info.provider';


@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private loginInfoProvider: LoginInfoProvider,
    private commonDataSharedService: CommonDataSharedService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.loginInfoProvider.loginInfo.isLogin) {
      return true;
    }

    this.commonDataSharedService.showStudentProfilePopup.next(true);
    this.router.navigate(['login'], { queryParams: { returnUrl: state.url }});
    return false;
  }
}
